import { IfDisplayPopupItem } from 'models/IfDisplayPopupItem';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACTION_TYPES } from 'store/ActionTypes';

export type POPUP_TYPE = 'cookie' | 'intro' | 'center' | 'centerMain';

export const useDisplayPopupItem = (): {
  displayPopupItem: IfDisplayPopupItem;
  setDisplayPopupItem: (b: IfDisplayPopupItem) => void;
  popupEnabled: (popupType: POPUP_TYPE) => boolean;
} => {
  const dispatch = useDispatch();
  const displayPopupItem: IfDisplayPopupItem = useSelector((state: any) => state.main.displayPopupItem);
  const setDisplayPopupItem = useCallback(
    (b: IfDisplayPopupItem) => {
      dispatch({ type: ACTION_TYPES.MAIN.DISPLAY_POPUP_ITEM, payload: b });
    },
    [dispatch]
  );
  const popupEnabled = useCallback(
    (popupType: POPUP_TYPE) => {
      if (!displayPopupItem) return false;
      if (popupType === 'cookie') {
        return displayPopupItem.cookie;
      } else if (popupType === 'intro') {
        return !displayPopupItem.cookie && displayPopupItem.intro;
      } else if (popupType === 'center' || popupType === 'centerMain') {
        return (
          (displayPopupItem.center || displayPopupItem.centerMain) &&
          !displayPopupItem.cookie &&
          !displayPopupItem.intro
        );
      }

      return;
    },
    [displayPopupItem]
  );
  return { displayPopupItem, setDisplayPopupItem, popupEnabled };
};

export const useDisplayBottomPopup = (): {
  displayBottomPopup: boolean;
  setDisplayBottomPopup: (b: boolean) => void;
} => {
  const dispatch = useDispatch();
  const displayBottomPopup = useSelector((state: any) => state.main.displayBottomPopup);
  const setDisplayBottomPopup = useCallback(
    (b: boolean) => {
      dispatch({ type: ACTION_TYPES.MAIN.DISPLAY_BOTTOM_POPUP, payload: b });
    },
    [dispatch]
  );
  return { displayBottomPopup, setDisplayBottomPopup };
};
